import React from 'react'
import { IoHome } from 'react-icons/io5'
import ArtistList from '../components/ArtistList'
import { BackButton } from '../components/BackButton'

export default function ArtistsPage() {
  return (
    <>
      <BackButton to="/" icon={<IoHome data-set="user-icon" />}>
        <span>Home</span>
      </BackButton>
      <ArtistList />
    </>
  )
}
